import { useEffect, useState } from 'react';
import { Badge } from 'antd';

import { useLazyGetAllReferencesQuery } from 'app/services/edpApiV1/references';

import { dataForReferencesTable, sortingDate } from 'shared/helpers/utils';
import { RequestsSearch, TColumns } from 'shared/types/types';

import { TableInProgress } from 'features/tables';
import { useIndicators } from 'features/indicators';
import { TPreparedReferencesTableData } from 'shared/types/reference.types';
import { SearchKeysNews } from 'shared/enums/news';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import { useAppSelector } from 'app/store';

const ReferencesInWaiting = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentSize, setCurrentSize] = useState<number>(10);
  const [dataReferences, setDataReferences] = useState<TPreparedReferencesTableData[]>();
  const [search, setSearch] = useState<RequestsSearch>({ byId: undefined, fio: undefined });
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const columns: TColumns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'key',
      width: 120,
    },
    {
      title: 'Дата',
      dataIndex: 'created',
      key: 'created',
      sorter: (a, b) => sortingDate(a.created, b.created),
    },
    {
      title: 'Вид справки',
      dataIndex: 'refTypeName',
      key: 'refTypeName',
    },
    {
      title: 'Период',
      dataIndex: 'year',
      key: 'year',
    },
    {
      title: 'Ф.И.О',
      dataIndex: 'fio',
      key: 'fio',
    },
    {
      title: 'Получение',
      dataIndex: 'gettingMethod',
      key: 'gettingMethod',
    },
    {
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
      render: status => (
        <span className="d-flex">
          <Badge status={status.type} />
          {status.text}
        </span>
      ),
    },
  ];

  const [getReferences, { data, isFetching, isSuccess }] = useLazyGetAllReferencesQuery();

  useEffect(() => {
    getReferences({
      type: 'myWaiting',
      size: 10,
      page: currentPage,
      allAvailableOrganizations,
      ...search,
    });
  }, [currentPage, currentSize, getReferences, search, allAvailableOrganizations]);

  useEffect(() => {
    if (data) {
      const dataTable = dataForReferencesTable(data?.data);
      if (dataTable) {
        setDataReferences(dataTable);
      }
    }
  }, [data]);

  const onSearch = (data: string, key: SearchKeysNews) => {
    if (key === SearchKeysNews.SEARCH_ID) {
      setSearch({ fio: undefined, byId: data ? data : undefined });
    } else if (key === SearchKeysNews.SEARCH_NAME) {
      setSearch({ byId: undefined, fio: data ? data : undefined });
    } else {
      setSearch({ [key]: data ? data : undefined });
    }
  };
  useIndicators(isSuccess, isFetching);
  return (
    <>
      {dataReferences && (
        <TableInProgress
          dataSource={dataReferences}
          columns={columns}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          currentSize={currentSize}
          setCurrentSize={setCurrentSize}
          total={data?.pagination?.total}
          onSearch={onSearch}
        />
      )}
    </>
  );
};

export default ReferencesInWaiting;
